import styled from 'styled-components';
import { appTheme } from '../../theme';
import SecondaryTitle from './SecondaryTitle';

const DetailsTitle = styled(SecondaryTitle)`
  border-color: ${appTheme.system.title};
  color: ${appTheme.system.title};
`;

export default DetailsTitle;



// WEBPACK FOOTER //
// ./src/modules/common/DetailsTitle.js